// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file organization_type.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file organization_type.proto.
 */
export const file_organization_type: GenFile = /*@__PURE__*/
  fileDesc("Chdvcmdhbml6YXRpb25fdHlwZS5wcm90bxIGZG9tYWluKlAKEE9yZ2FuaXphdGlvblR5cGUSHQoZT1JHQU5JWkFUSU9OX1RZUEVfVU5LTk9XThAAEh0KGU9SR0FOSVpBVElPTl9UWVBFX0NPTVBBTlkQAUIwWi5naXRsYWIuY29tL2NvdGVjaGRlL21vbm9yZXBvL2JhY2tlbmQvZG9tYWluL3BiYgZwcm90bzM");

/**
 * @generated from enum domain.OrganizationType
 */
export enum OrganizationType {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: ORGANIZATION_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * ORGANIZATION_TYPE_FAMILY = 2;
   *
   * @generated from enum value: ORGANIZATION_TYPE_COMPANY = 1;
   */
  COMPANY = 1,
}

/**
 * Describes the enum domain.OrganizationType.
 */
export const OrganizationTypeSchema: GenEnum<OrganizationType> = /*@__PURE__*/
  enumDesc(file_organization_type, 0);

